import Edit from "./Edit.vue";

export default [
  {
    path: "edit",
    name: "UsersPasswordEdit",
    component: Edit,
    meta: {
      title: "パスワード変更",
      tree: [{ title: "パスワード変更" }],
    },
  },
];
